import React from 'react';
import { JESSICA_PHOTO } from '../../../constants/site';

const NAME_STYLE = { letterSpacing: '0.08em', textShadow: '0 0 30px rgba(255,255,255,0.5), 0 4px 12px rgba(0,0,0,0.8)' };

export const HeroIdentity = () => (
  <>
    <div className="relative">
      <div className="absolute -inset-6 bg-gradient-to-br from-gold-400/30 via-gold-500/20 to-gold-600/30 blur-3xl rounded-full"></div>
      <div className="relative w-56 sm:w-72 lg:w-80 aspect-[3/4] rounded-2xl overflow-hidden border-2 border-gold-400/70 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.7)] rotate-[-2deg] hover:rotate-0 transition-transform duration-500">
        <img src={JESSICA_PHOTO} alt="Jessica Burnette – Top REALTOR® serving Virginia Beach, the Outer Banks, and Coastal Virginia & North Carolina" className="w-full h-full object-cover object-top" fetchPriority="high" decoding="async" />
      </div>
    </div>
    <div className="text-center lg:text-left space-y-2">
      <p className="text-4xl sm:text-5xl lg:text-6xl font-cursive font-bold text-white drop-shadow-2xl" style={NAME_STYLE}>Jessica Burnette</p>
      <p className="text-xl sm:text-2xl font-black tracking-wide gold-gradient-text">BUY, SELL, INVEST WITH JESS</p>
      <h1 id="hero-heading" data-testid="hero-h1" className="text-base sm:text-lg text-white/90 font-semibold drop-shadow-lg leading-snug">
        <span className="block">Top REALTOR® in Virginia Beach &amp; the Outer Banks</span>
        <span className="block">Luxury Coastal Real Estate in Virginia &amp; North Carolina</span>
      </h1>
      <p className="text-base sm:text-lg text-white/90 font-semibold drop-shadow-lg">Military Relocation Specialist (MRP®)</p>
      <div className="flex items-center justify-center lg:justify-start space-x-2 mt-2">
        <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border border-gold-400/50">
          <p className="text-sm sm:text-base text-gold-400 font-bold">⭐ Veterans United Preferred Agent</p>
        </div>
      </div>
    </div>
  </>
);
